firebird.controller('presenterGreenRoomTimeNotificationCtrl', [
    '$scope',
    '$interval',
    'growlService',
    'meetingService',
    'routerService',
    'meetingMomentsService',
    function ($scope, $interval, growlService, meetingService, routerService, meetingMomentsService) {
        var self = this;

        self.remainingSeconds = 0;
        self.isFirstAlertShown = false;
        self.showSecondAlert = false;
        self.message = '';

        self.isBannerClosed = false;
        self.checkAndShowFirstAlert = checkAndShowFirstAlert;
        self.checkAndShowSecondAlert = checkAndShowSecondAlert;
        self.setupDurationTimer = setupDurationTimer;
        self.closeBanner = closeBanner;
        self.goLive = goLive;
        self.checkTimeAndShowAlert = checkTimeAndShowAlert;

        var firstAlertSeconds = 15 * 60;
        var secondAlertSeconds = 5 * 60;

        init();

        ////////////////////////

        function init() {
            self.setupDurationTimer();
        }

        function setupDurationTimer() {
            var intervalTime = 10;
            self.checkTimeAndShowAlert();
            self.durationInterval = $interval(function () {
                self.checkTimeAndShowAlert();
            }, intervalTime * 1000);
        }

        function checkTimeAndShowAlert() {
            self.remainingSeconds = Math.round(meetingMomentsService.getTicksBeforeScheduledStart() / 1000);
            self.checkAndShowFirstAlert();
            self.checkAndShowSecondAlert();
        }

        function generateMessage() {
            var minutesLeft = Math.max(Math.round(self.remainingSeconds / 60), 0);
            return (
                'Your Live Webinar will start in ' +
                minutesLeft +
                ' min. Please end the Practice Webinar and start your Live Webinar'
            );
        }

        function checkAndShowFirstAlert() {
            if (
                self.remainingSeconds <= firstAlertSeconds &&
                self.remainingSeconds > secondAlertSeconds &&
                !self.isFirstAlertShown
            ) {
                growlService.show(generateMessage(), 'info', '');
                self.isFirstAlertShown = true;
            }
        }

        function checkAndShowSecondAlert() {
            if (self.isBannerClosed) {
                self.showSecondAlert = false;
                return;
            }
            if (self.remainingSeconds <= secondAlertSeconds && self.remainingSeconds > -1 * 60) {
                self.showSecondAlert = true;
                self.message = generateMessage();
            } else {
                self.showSecondAlert = false;
            }
        }

        function closeBanner() {
            self.isBannerClosed = true;
            checkAndShowSecondAlert();
        }

        function goLive() {
            var accessCode = meetingService.getParentMeetingAccessCode();
            routerService.resolveInitialPath(accessCode);
        }
    }
]);
